export const subtitles = {
    "1": {
        "startTime": 11.69,
        "endTime": 22.46,
        "transcript": "Tua-ll' ayagyuallerpeni-qaa qasgimi, qasgimi uitaqallruuten?",
        "translation": "So, when you were young, did you live in the community house?"
    },
    "2": {
        "startTime": 22.46,
        "endTime": 29.84,
        "transcript": "Qaillun-llu ayuqellrua ayagyuallerpeni, miklerpeni, ellangellerpeni tamaani?",
        "translation": "And what was it like when you were young, when you were small, in your earliest memories back then?"
    },
    "3": {
        "startTime": 29.845,
        "endTime": 32.925,
        "transcript": "Qaill' ayuqellruat tamakut yullret?",
        "translation": "What were those people like back then?"
    },
    "4": {
        "startTime": 33.18,
        "endTime": 36.15,
        "transcript": "Qinarmiuni ellangellruunga.",
        "translation": "My earliest memories are in Qinarmiut."
    },
    "5": {
        "startTime": 36.58,
        "endTime": 46.36,
        "transcript": "Ellanglua tua-i ellangellemni cataitellruuq Qinaq, mat'umek-ll' Qaneryaramek pitaunani.",
        "translation": "In my earliest memories growing up, there was nothing [Western] in Qinaq, and there was no Bible."
    },
    "6": {
        "startTime": 46.705,
        "endTime": 50.455,
        "transcript": "Agayumalriartaunani.",
        "translation": "There were no Christians."
    },
    "7": {
        "startTime": 50.625,
        "endTime": 59.76,
        "transcript": "Tua-i ellangeqarraallruunga waten kinguqlimnun tuqulriamun tungemnun.",
        "translation": "My earliest memories are right after my younger sibling who died."
    },
    "8": {
        "startTime": 59.76,
        "endTime": 66.55,
        "transcript": "Tua-i tuaken ayaglua ellanglua. Yuut tua-i nallunrirluki Qinarmi.",
        "translation": "I've had consistent memories since then. I got to know the people in Qinaq."
    },
    "9": {
        "startTime": 66.94,
        "endTime": 71.45,
        "transcript": "Tua-i tuaken ayaglua ellanglua yuut murilkelluki.",
        "translation": "I've had consistent memories since then, observing the people."
    },
    "10": {
        "startTime": 71.45,
        "endTime": 73.77,
        "transcript": "Qinarmiungulua tua-i.",
        "translation": "I was a resident of Qinaq."
    },
    "11": {
        "startTime": 75.935,
        "endTime": 82.845,
        "transcript": "Tua-i-llu atam pinariama",
        "translation": "Then, you see, when I became capable"
    },
    "12": {
        "startTime": 83.005,
        "endTime": 93.165,
        "transcript": "Kass'at-llu enurnarluteng, ataucirrarmek tau͡gaam Kass'artarluteng, wagg'uq uumek Klondike Johnson, Yugtun piaqluku Parumek.",
        "translation": "There were scarcely any Caucasians, but there was only one Caucasian there, whom they called Klondike Johnson, whom they called Paru in Yup'ik."
    },
    "13": {
        "startTime": 93.5,
        "endTime": 97.62,
        "transcript": "Irniari-wa cetaman tan'gaurluullgutekluki tua-i.",
        "translation": "His four children were our fellow boys."
    },
    "14": {
        "startTime": 97.625,
        "endTime": 101.565,
        "transcript": "Malruk tayim' unguvauk, nuu, pingayun.",
        "translation": "Two are alive, no, three."
    },
    "15": {
        "startTime": 102.62,
        "endTime": 107.62,
        "transcript": "Alikaqa tau͡gaam tauna Paru. Kass'at alikellruaput.",
        "translation": "But I was scared of Paru. We were scared of Caucasians."
    },
    "16": {
        "startTime": 107.625,
        "endTime": 111.58,
        "transcript": "Carayakluki tua-i. Tangrraqamki, \"Aullu, tarrarrngaitua.\"",
        "translation": "They were strange being to us. When I saw them, \"Oh my, I won't walk about.\""
    },
    "17": {
        "startTime": 111.58,
        "endTime": 113.26,
        "transcript": "Tua-i alingnaqluteng.",
        "translation": "They were scary."
    },
    "18": {
        "startTime": 113.265,
        "endTime": 119.945,
        "transcript": "Qinarmiut tua-i taukut yuuluteng, elitnaurviinateng-llu.",
        "translation": "The people of Qinaq lived there, and they didn't have a school."
    },
    "19": {
        "startTime": 120.39,
        "endTime": 128.38,
        "transcript": "Angliriama-llu qasgimun cali itraqama, qasgiaqama",
        "translation": "Then when I went into the community house when I grew up, when I was at the community house"
    },
    "20": {
        "startTime": 130.37,
        "endTime": 141.6,
        "transcript": "Tauna cunaw' aiparkama, ug'um aiparkama apa'urlua Akagtaq tua-i alikluku.",
        "translation": "I was scared of Akagtaq, the grandfather of the one who ended up being my future spouse, my future spouse downriver."
    },
    "21": {
        "startTime": 141.6,
        "endTime": 147.56,
        "transcript": "Maurlurlumnek cali taumek friend-angqelliniami itrumaaqami",
        "translation": "When he was in there, since he apparently was friends with my grandmother"
    },
    "22": {
        "startTime": 148.595,
        "endTime": 153.67,
        "transcript": "Taum maurlurluma egyaqsuani-llu",
        "translation": "Also since my grandmother would [?joke about] him"
    },
    "23": {
        "startTime": 153.67,
        "endTime": 159.29,
        "transcript": "Tua-i alikluku cali ilumun yugnek nertuyukluku.",
        "translation": "I was scared of him, thinking that he really did eat people."
    },
    "24": {
        "startTime": 159.295,
        "endTime": 162.095,
        "transcript": "Cunaw' tutgarqelliniamia.",
        "translation": "Apparently, it was because I was her grandchild."
    },
    "25": {
        "startTime": 162.49,
        "endTime": 169.92,
        "transcript": "Tua-i ukvekpiarluku nevukun-llu ciutengqerrniluni.",
        "translation": "And I believed her, and s said that she had ears in the soil."
    },
    "26": {
        "startTime": 169.92,
        "endTime": 178.16,
        "transcript": "Amani enemeggni uitaurarqami cauralriit amkut tua-i niirquratuniluku.",
        "translation": "When she was in her house, she said that she heard what was going on [in the community house] over there."
    },
    "27": {
        "startTime": 178.165,
        "endTime": 186.395,
        "transcript": "Tua-i taumek neqamlinguaqerqamku tua-i cukaqangraan unuamek maa-i qanlalrianga",
        "translation": "That's why when I [?remember] her, however briefly, I say today"
    },
    "28": {
        "startTime": 186.395,
        "endTime": 195.745,
        "transcript": "\"Nutaan-tuq imna tayima nevukun ciutengqerrnilalleq yav'anun phone-arcet'larlaku ingrit aciatgun.\"",
        "translation": "\"How I wish I could have that one who said she had ears in the soil make phone calls far away under the mountains.\""
    },
    "29": {
        "startTime": 195.745,
        "endTime": 199.66,
        "transcript": "Tua-i tuaten ayuqluteng Qinarmiut.",
        "translation": "That's what the people of Qinaq were like."
    },
    "30": {
        "startTime": 199.66,
        "endTime": 204.4,
        "transcript": "Tua-llu tua-i atam qasgilangama",
        "translation": "Then, you see, when I started going to the community house"
    },
    "31": {
        "startTime": 206.085,
        "endTime": 211.045,
        "transcript": "Yuut, qasgilangvailegma tamaani atam",
        "translation": "The people, before I started going to the community house back then, you see"
    },
    "32": {
        "startTime": 211.54,
        "endTime": 221.0,
        "transcript": "Waten yuut qetunracuarateng wall'u paniteng",
        "translation": "People [did] this with their little sons or their daughters"
    },
    "33": {
        "startTime": 221.005,
        "endTime": 231.215,
        "transcript": "Yuullermeggni camek unangaqata, pitqerriirqata boy-acuarateng, pitgarluki",
        "translation": "When they caught something in their lives, when their little boys had their first catches with arrows"
    },
    "34": {
        "startTime": 231.365,
        "endTime": 240.775,
        "transcript": "Imna tua-i yaquleyagaq kemgirluku, nakaculiluki, ayagcirluku kinertelluku.",
        "translation": "They would remove the flesh from their bones, hang them, prop them to dry them."
    },
    "35": {
        "startTime": 241.005,
        "endTime": 246.9,
        "transcript": "Tua-i-llu uksuquan kalukarluku.",
        "translation": "Then the next winter, they would hold a feast for that."
    },
    "36": {
        "startTime": 246.9,
        "endTime": 249.92,
        "transcript": "Tuaten tua-i allamiaqan pituluteng.",
        "translation": "They would do that every year."
    },
    "37": {
        "startTime": 249.925,
        "endTime": 255.62,
        "transcript": "Tua-i-ll' wiinga pavani uani neqlillemteńi ak'a",
        "translation": "Then inland, downriver at our fish camp back then"
    },
    "38": {
        "startTime": 255.62,
        "endTime": 262.39,
        "transcript": "Tagyaram uatiini pavani-am tarrarluta pillemteńi, tua-i aqvaqulanglua",
        "translation": "When we were wanding downriver from Tagyaraq in land, when I had started running"
    },
    "39": {
        "startTime": 262.39,
        "endTime": 267.59,
        "transcript": "Atam qangqiiq man'a tengvallagyaaqelria igtellria.",
        "translation": "You see, this ptarmigan that had taken off in flight fell."
    },
    "40": {
        "startTime": 267.595,
        "endTime": 270.93,
        "transcript": "Malirqerqamni tua-i tengvallaggaarluni igtaq[luni].",
        "translation": "As I chased it, it would take off then fall."
    },
    "41": {
        "startTime": 270.93,
        "endTime": 274.61,
        "transcript": "Caqerluku tua-i paallaglua teguluku.",
        "translation": "Eventualy, I tripped and took it."
    },
    "42": {
        "startTime": 274.835,
        "endTime": 279.565,
        "transcript": "Tua-i tengssaangraan tengevkaryugnaunaku tuququaluku.",
        "translation": "Though it tried to fly away, I didn't let it and killed it."
    },
    "43": {
        "startTime": 279.565,
        "endTime": 283.145,
        "transcript": "Tayima tua-i qaillun piciinaku.",
        "translation": "I didn't know what became of it."
    },
    "44": {
        "startTime": 283.23,
        "endTime": 292.86,
        "transcript": "Cunaw' tua-i tauma maurlurluma nakaculillinikii tuaten tua-i.",
        "translation": "It turned out that my grandmother hung it to dry."
    },
    "45": {
        "startTime": 292.86,
        "endTime": 296.03,
        "transcript": "Nalluluku tangeqsaunaku-llu.",
        "translation": "I didn't know about it and never saw it."
    },
    "46": {
        "startTime": 296.92,
        "endTime": 304.61,
        "transcript": "Tua-i ugna uksuillerput Iingirayuq",
        "translation": "Our winter camp downriver, Iingirayuq"
    },
    "47": {
        "startTime": 307.82,
        "endTime": 315.32,
        "transcript": "Family-t pingayun waten taluyarpagcutullruut.",
        "translation": "Three familes would set large fishtraps like this."
    },
    "48": {
        "startTime": 315.325,
        "endTime": 323.335,
        "transcript": "Whitefish-anek, akakiignek, cingikegglinek neqsutuluteng.",
        "translation": "They would fish for whitefish, broad whitefish, whitefish with pointed heads."
    },
    "49": {
        "startTime": 323.335,
        "endTime": 331.845,
        "transcript": "Tua-i-ll' aatama taum taluyillra cali kan'a nunat aciat, tauna neqtuluni tayima tua-i.",
        "translation": "Them my father's fish trapping spot down there under the ground would have a lot of fish."
    },
    "50": {
        "startTime": 331.845,
        "endTime": 339.62,
        "transcript": "Atam uksuquan Qinarmiut kelelriit.",
        "translation": "You see, the next winter, the people of Qinaq sent invitations."
    },
    "51": {
        "startTime": 339.62,
        "endTime": 348.81,
        "transcript": "Kelellinilriit Iigmun, Apruka'armun-llu Apruka'armiut yungqellratni, tuaten pitullruameng.",
        "translation": "They sent invitations to Eek, and to Apruka'ar when there were people in Apruka'ar, because that's what they did."
    },
    "52": {
        "startTime": 348.81,
        "endTime": 352.14,
        "transcript": "Tua-i allanret tekilluteng.",
        "translation": "The guests arrived."
    },
    "53": {
        "startTime": 352.147,
        "endTime": 361.176,
        "transcript": "Atam akutetullruut qantav'agteggun",
        "translation": "You see, they would make Yup'ik ice cream with huge bowls"
    },
    "54": {
        "startTime": 362.731,
        "endTime": 376.32,
        "transcript": "Akutapianek tunulegnek, uqunek egcetaarluki tangviarrluut kenirluki, ingqiqcaarluki tamaani akutetullermeggni.",
        "translation": "Traditional Yup'ik ice cream with tallow, cooking seal blubber to render their oil, and cutting them up back when they made Yup'ik ice cream [like that]."
    },
    "55": {
        "startTime": 376.65,
        "endTime": 384.006,
        "transcript": "Tua-i-llu ala pikiitnga, qasgilii-gguq, maligglaki-gguq.",
        "translation": "Then, oh my, they told me to go to the community house, to go with [the men]."
    },
    "56": {
        "startTime": 384.012,
        "endTime": 393.512,
        "transcript": "Maaten anua ikamrak tua-i au͡gkuk atama neqnek tua-i iqukliarrlutek imarlutek.",
        "translation": "I went out and found that my father's sled was filled end to end with fish."
    },
    "57": {
        "startTime": 393.523,
        "endTime": 397.423,
        "transcript": "Una-w' tang miskav'all'er akutamek imarluni.",
        "translation": "This huge serving bowl, you see, had Yup'ik ice cream."
    },
    "58": {
        "startTime": 397.437,
        "endTime": 405.015,
        "transcript": "Imna-wa tang una qanqiirtalqa kiak ayagterluni akutami kapuyuterluni kapusngalria.",
        "translation": "Then, you see, the ptarmigan I'd caught last sumemr had a prop and was stuck to the Yup'ik ice cream with a stake."
    },
    "59": {
        "startTime": 405.21,
        "endTime": 409.921,
        "transcript": "Tua-i kalukallinikiinga taum aatama.",
        "translation": "Apparently, my father held a feast for me."
    },
    "60": {
        "startTime": 409.929,
        "endTime": 415.872,
        "transcript": "Qasginritua. Arenqiatuq taumek imumek yugtutulimek alingua.",
        "translation": "I didn't go to the community house. It was distressing since I was agraid of that cannibal."
    },
    "61": {
        "startTime": 415.887,
        "endTime": 422.742,
        "transcript": "Maligtenritaqa alikataqa tauna unguviin tamaani.",
        "translation": "I didn't go with him because the one I was afraid of was alive there."
    },
    "62": {
        "startTime": 422.754,
        "endTime": 425.465,
        "transcript": "Tua-i tuaten pitullruut.",
        "translation": "That's what they used to do."
    },
    "63": {
        "startTime": 425.473,
        "endTime": 431.429,
        "transcript": "Tua-i-llu au͡gna tua-i kassiyuq iqukliartuq.",
        "translation": "That dancing festival was over."
    },
    "64": {
        "startTime": 431.435,
        "endTime": 439.102,
        "transcript": "Atam cali nutaan qasgimi, qasgimi qavalangelriakut.",
        "translation": "You see, we finally started sleeping in the community house."
    },
    "65": {
        "startTime": 439.119,
        "endTime": 445.152,
        "transcript": "Qasgi tua-i imna qasegpall'er qaillun tayima angtaa.",
        "translation": "That huge community house, I'm not sure how big it was."
    },
    "66": {
        "startTime": 445.453,
        "endTime": 455.286,
        "transcript": "Tua-i ayagyuanek ciulirnemteńek-llu inartaqata piviitnaurtuq.",
        "translation": "When young people and our elders lay down for bed, there'd be no room."
    },
    "67": {
        "startTime": 455.296,
        "endTime": 468.563,
        "transcript": "Kinguqvaarkun tua-i itellriani, iliini uani tua-i amiigen, acikaitaqama amiigem aciani ciuqerrani qavalartua canirrlua.",
        "translation": "When I went in late, sometimes, I would sleep on my side down under the door, in front of it, when I had no bedding."
    },
    "68": {
        "startTime": 468.998,
        "endTime": 471.665,
        "transcript": "Tuaten tua-i.",
        "translation": "Like that."
    },
    "69": {
        "startTime": 471.939,
        "endTime": 481.006,
        "transcript": "Tua-i tau͡gken unuakumi iliini qanerturalrianun tupagnaurtua pak'mumun.",
        "translation": "Some mornings, however, I would wake up to someone instructing up there."
    },
    "70": {
        "startTime": 481.011,
        "endTime": 492.255,
        "transcript": "Ak'a tua-i angukara'urluut iliit qanerturangellinilria ayuqucirtuutmek, qanruyutmek, yuum yuullerkaanek",
        "translation": "One of the old men would already be speaking about instructions, traditional wisdom, how a person should live"
    },
    "71": {
        "startTime": 492.271,
        "endTime": 501.371,
        "transcript": "Tan'gaurluum yuullerkaanek, uk'umek agiirtellriamek atu'urkamek, piciulriamek.",
        "translation": "How a boy should live, what is in store for the future, true things."
    },
    "72": {
        "startTime": 501.781,
        "endTime": 511.57,
        "transcript": "Tua-i pekqullagavkenata tua-i maktaqamta tua-i maktaqluta niicugniurluku tauna qanerturalria.",
        "translation": "When we got up, we'd get up without sudden movements, listening to the one giving instruction."
    },
    "73": {
        "startTime": 511.58,
        "endTime": 514.314,
        "transcript": "Tupaqluta piyuunata.",
        "translation": "We wouldn't [?be forecefully awoken]."
    },
    "74": {
        "startTime": 515.003,
        "endTime": 518.403,
        "transcript": "Tuaten tua-i unuakut tamaita.",
        "translation": "That happened every morning."
    },
    "75": {
        "startTime": 518.411,
        "endTime": 525.689,
        "transcript": "Tuamtellu erenrani waten maqillmeng qamanran maqirpatuameng-llu",
        "translation": "Then during the day like this, when their fire bath was going out since they had blazing fire baths"
    },
    "76": {
        "startTime": 525.789,
        "endTime": 534.334,
        "transcript": "Qanerturnaurtut yuullerkamek uk'umek agiirtellriamek.",
        "translation": "They would give life instruction about what was in the near future."
    },
    "77": {
        "startTime": 534.6,
        "endTime": 542.177,
        "transcript": "Tan'gaurluq arnamun elliqan, aren cayugnailngukut-wa.",
        "translation": "If a boy marries a woman, oh my, it was a long way off for us."
    },
    "78": {
        "startTime": 542.183,
        "endTime": 546.083,
        "transcript": "Agiirtell[riamek] pellaayairturluta cunaw'.",
        "translation": "It turned out, they kept us from being lost in the future."
    },
    "79": {
        "startTime": 547.362,
        "endTime": 552.017,
        "transcript": "Tua-i tuaten pinaurtut. Tua-llu tua una nangqe'rtuq.",
        "translation": "They would say that. This [topic] is finished."
    },
    "80": {
        "startTime": 552.03,
        "endTime": 555.408,
        "transcript": "Tua-ll' nutaan qalangssalartut.",
        "translation": "Then they would tell stories."
    },
    "81": {
        "startTime": 556.581,
        "endTime": 566.715,
        "transcript": "Tamaani-gguq ciungani tamatum wangkuta yuurpailemta, tamakut-ll' angukara'urluut ayagyuarluki nutaan",
        "translation": "They said that in the past, before we were born, and when the old men were young"
    },
    "82": {
        "startTime": 566.754,
        "endTime": 569.698,
        "transcript": "Ayuqucirtuun pinirluku atullruat.",
        "translation": "They strongly practiced traditional instruction."
    },
    "83": {
        "startTime": 569.894,
        "endTime": 580.722,
        "transcript": "Qasgimi, ayuqucirturiqata'arqameng-gguq qasgimi ugna amiik imumek tua-i cigyagmek.",
        "translation": "They said that when they were going to give in struction in the community house, [they would place] a split spruce stick down at the door."
    },
    "84": {
        "startTime": 580.725,
        "endTime": 582.792,
        "transcript": "Cigyak-qaa nallunritan?",
        "translation": "Do you know split sprice?"
    },
    "85": {
        "startTime": 583.634,
        "endTime": 586.167,
        "transcript": "Iciw' taluyat imkut muriit.",
        "translation": "You know, wood to make fish traps."
    },
    "86": {
        "startTime": 586.186,
        "endTime": 589.72,
        "transcript": "Nauwa? Man'a-ggem pitangqellruuq.",
        "translation": "Where is it? Wasn't there one here?"
    },
    "87": {
        "startTime": 589.728,
        "endTime": 594.717,
        "transcript": "Taluyanek. Cigyangqelalriit waten iqtutauralrianek.",
        "translation": "[To make] fish traps. They have split spruce that are this wide."
    },
    "88": {
        "startTime": 594.731,
        "endTime": 599.809,
        "transcript": "Cani'irrvikaqaat qeratmun.",
        "translation": "They would put that crosswise on its side [in the door]."
    },
    "89": {
        "startTime": 599.822,
        "endTime": 602.766,
        "transcript": "Nutaan-llu qanruyutmek qalarrluteng.",
        "translation": "Then they'd speak of traditional wisdom."
    },
    "90": {
        "startTime": 602.768,
        "endTime": 614.362,
        "transcript": "Tua-lli-wa-gguq tua-i yuut ayuqenritliniameng waten, tan'gaurluut ayuqenritliniameng",
        "translation": "Then they said that since people are different like this, since boys are different"
    },
    "91": {
        "startTime": 614.37,
        "endTime": 624.314,
        "transcript": "Ilii-gguq tan'gaurluum anqertaquq qasgimek, imna tamana tapeqluku asemlluku.",
        "translation": "They said that some boy would go out of the community house, even breaking that [split spruce]."
    },
    "92": {
        "startTime": 624.713,
        "endTime": 631.058,
        "transcript": "Wangliungeqatartut-am, \"Aren, arivanrilkii-w' qaneryaram.\"",
        "translation": "They'd start talking about him, \"Oh my, the traditional wisdom doesn't call to him.\""
    },
    "93": {
        "startTime": 631.069,
        "endTime": 640.136,
        "transcript": "They said that a bad person, a bad person does that.",
        "translation": "They said that a bad person, a bad person does that."
    },
    "94": {
        "startTime": 641.543,
        "endTime": 656.139,
        "transcript": "Tuamtellu qakmani arnat cali allakarmeng eneni arnassagallraat imkut eliperneret ayuqucirtuaguratullruit",
        "translation": "Then the women, separate out there in the houses, the [?elderly] old women would always isntruct them"
    },
    "95": {
        "startTime": 656.732,
        "endTime": 663.654,
        "transcript": "Nasaurluq uingekan tuaten uinganek aulukillerkaa.",
        "translation": "How a girl should take care of her husband when she takes a husband."
    },
    "96": {
        "startTime": 663.666,
        "endTime": 667.933,
        "transcript": "Tua-lli waten anguanka tuani tua-i uksuillerni.",
        "translation": "Then I caught them [instructing] there in the winter camp."
    },
    "97": {
        "startTime": 669.361,
        "endTime": 678.738,
        "transcript": "Ena amiik uaken caniqerrilitarluni canegnek, naqugtarnek tupigluki iterniryailkutnek.",
        "translation": "The house's door had grass placed on the side, woven grass belts to keep out the draft."
    },
    "98": {
        "startTime": 679.791,
        "endTime": 684.469,
        "transcript": "Tua-lli-wa-gguq nevilleraat iliit-am cali",
        "translation": "Then, one of the girls too"
    },
    "99": {
        "startTime": 684.482,
        "endTime": 690.849,
        "transcript": "Waten family-nek ena atauciq pingayunek enelgutkurpallutullruut, murilkanka.",
        "translation": "I observed that one house like this would have three families living together."
    },
    "100": {
        "startTime": 690.861,
        "endTime": 696.316,
        "transcript": "Cetamanek-llu yungqetullrulria family-nek.",
        "translation": "It would also be occupied by four families."
    },
    "101": {
        "startTime": 696.329,
        "endTime": 700.351,
        "transcript": "Nevilleraat-gguq iliit anqertaquq.",
        "translation": "They said that one of the girls would run out."
    },
    "102": {
        "startTime": 700.36,
        "endTime": 703.193,
        "transcript": "Tua-llam wangliungeqatartut.",
        "translation": "Then they'd start speaking of her."
    },
    "103": {
        "startTime": 703.212,
        "endTime": 718.687,
        "transcript": "Iliin-llu-gguq imkut ingkut caniqerrilitat tapeqluki au͡g'arluki kapuyukaralget can'get.",
        "translation": "They said that one would even take of the grass block that was stuck with tacks."
    },
    "104": {
        "startTime": 719.693,
        "endTime": 726.793,
        "transcript": "Tua-i pingayiriaqan-gguq arnassagallraam im' taquitaqaa.",
        "translation": "They said that when it happened for the third time, the old woman gives her [her future]."
    },
    "105": {
        "startTime": 727.7,
        "endTime": 734.825,
        "transcript": "\"Atak'-gguq au͡gna tua-i pili, caniqaam yukniaraa.\"",
        "translation": "\"Let her do that, so that she will be the person of the threshhold.\""
    },
    "106": {
        "startTime": 734.831,
        "endTime": 737.106,
        "transcript": "Caniqaq-qaa nallunritan?",
        "translation": "Do you know what a caniqaq is?"
    },
    "107": {
        "startTime": 737.125,
        "endTime": 738.662,
        "transcript": "Nauwa?",
        "translation": "Where is it?"
    },
    "108": {
        "startTime": 738.675,
        "endTime": 743.487,
        "transcript": "Amiigem ug'um taqu͡ra caniqauguq.",
        "translation": "The threshhold of the door out there is a caniqaq."
    },
    "109": {
        "startTime": 743.488,
        "endTime": 747.2,
        "transcript": "Caniqamek pituat, caniqaq.",
        "translation": "They call it a caniqaq."
    },
    "110": {
        "startTime": 747.201,
        "endTime": 755.351,
        "transcript": "Qau͡gna-wa enem egkua kitkacagaani amiigem ciuqra qau͡gna egkuq. Makuk-wa tua-i taquuk.",
        "translation": "Inside in the wall of the house, the area in front of the door is the egkuq. These are the taquuk [threshold]."
    },
    "111": {
        "startTime": 755.37,
        "endTime": 759.245,
        "transcript": "Tuaten igloo-nek [enepianek] enengqellermeggni.",
        "translation": "Like that, when they had sod houses."
    },
    "112": {
        "startTime": 759.251,
        "endTime": 762.064,
        "transcript": "\"Caniqaam yukniaraa.\"",
        "translation": "\"Let her be the person of the threshhold.\""
    },
    "113": {
        "startTime": 762.076,
        "endTime": 769.839,
        "transcript": "Aren, kingunertaqaa-gguq. Caniqaq-llu yuungnaqelriit atutukiit.",
        "translation": "Oh my, they said she would [?call her back]. Those who subsist also use the threshold."
    },
    "114": {
        "startTime": 769.851,
        "endTime": 772.114,
        "transcript": "\"Natrem yukniaraa.\"",
        "translation": "\"Let her be the person of the floor.\""
    },
    "115": {
        "startTime": 772.126,
        "endTime": 776.664,
        "transcript": "Cuna-gguq tua-i ciunra, ciunerkaa enik'acagarluku.",
        "translation": "Apparently, it was because she was [?weighing down] her future."
    },
    "116": {
        "startTime": 776.677,
        "endTime": 786.927,
        "transcript": "Aanairulluni, aatairulluni, wantaqluni, wantaqluni qanruyun atunritem ugaani.",
        "translation": "She loses her mother, father, stays here, stays here, because she doesn't practice traditional wisdom."
    },
    "117": {
        "startTime": 787.409,
        "endTime": 793.921,
        "transcript": "Tuamtellu qakmani tauna im' qasgimi anqertelalleq",
        "translation": "Then outside in the community house, the one who would run out"
    },
    "118": {
        "startTime": 793.934,
        "endTime": 799.509,
        "transcript": "Pingayiriaqan-gguq tua-i angullualleraam taquitaqaa.",
        "translation": "They said when he does that a third time, an old man gives him [his future]."
    },
    "119": {
        "startTime": 799.515,
        "endTime": 807.803,
        "transcript": "\"Atak'-gguq au͡gna tua-i pili, qengaruum iquani keggutekegciniartuq.\"",
        "translation": "\"Let him do that, so he will show his nice teeth at the end of a snowbank.\""
    },
    "120": {
        "startTime": 807.816,
        "endTime": 809.728,
        "transcript": "Taringan-qaa?",
        "translation": "Do you understand it?"
    },
    "121": {
        "startTime": 809.741,
        "endTime": 812.104,
        "transcript": "Waten mean-angqertuq:",
        "translation": "This is what it means:"
    },
    "122": {
        "startTime": 812.566,
        "endTime": 818.654,
        "transcript": "Iqukvat tamaita ellarrlugiurturatullermeggni, ellarrlugiutullermeggni",
        "translation": "When all [?] would always prefict bad weather bringing famines, when they predicted bad weather"
    },
    "123": {
        "startTime": 818.667,
        "endTime": 824.392,
        "transcript": "Tua-i-gguq paluluni mat'umun. Qengaruk-qaa nallunritan?",
        "translation": "They say he starves and [ends up] here. Do you know what a qengaruk [snowbank] is?"
    },
    "124": {
        "startTime": 824.411,
        "endTime": 826.161,
        "transcript": "Qanikcaq.",
        "translation": "It's snow."
    },
    "125": {
        "startTime": 826.53,
        "endTime": 832.38,
        "transcript": "Yaani iquani, keggutai-wa qercurpak.",
        "translation": "Over at the end, his teeth are very white."
    },
    "126": {
        "startTime": 832.399,
        "endTime": 838.787,
        "transcript": "Tua-i-gguq palu'urlurlullinilria.Tua-i keggutekegcialuni-gguq.",
        "translation": "They say the poor guy starved. They say he's showing his nice teeth."
    },
    "127": {
        "startTime": 838.8,
        "endTime": 844.037,
        "transcript": "Tua-i tuaten ayuqellrulliniut.",
        "translation": "That's what they were like."
    },
    "128": {
        "startTime": 844.05,
        "endTime": 853.162,
        "transcript": "Cali nasaurluut qalarutaqamegteki qanrutetulliniit",
        "translation": "Also, when they spoke to the girls, they would tell them"
    },
    "129": {
        "startTime": 853.163,
        "endTime": 858.638,
        "transcript": "\"Qayu-llu tua-i uingekuvet, uiu͡rlurpenek paluiciqelriaten.\"",
        "translation": "\"Should you end up taking a husband, your husband will starve on you.\""
    },
    "130": {
        "startTime": 858.657,
        "endTime": 864.182,
        "transcript": "Tang Kass'artaitellrani, una-wa uinga.",
        "translation": "You see, when there were no Caucasians, and here's her husband."
    },
    "131": {
        "startTime": 864.188,
        "endTime": 870.763,
        "transcript": "Tua-i-gguq ellarrluum nalliini",
        "translation": "They said that during bad weather causing famine"
    },
    "132": {
        "startTime": 870.779,
        "endTime": 881.354,
        "transcript": "Nutaan nulirqelriit ayuquciak, uiminun, nuliaminun ayuquciak nasva'gquq.",
        "translation": "That's when a married couples true character, their character towards their husbands, wives, are shown."
    },
    "133": {
        "startTime": 881.373,
        "endTime": 891.635,
        "transcript": "Yua-gguq iliin uiu͡rluni palivkatua nallmikun neryugluni, nangusnguarluni-llu.",
        "translation": "They say that some makes her husband starve, wanting to eat for herself, and pretending there's no food left."
    },
    "134": {
        "startTime": 892.048,
        "endTime": 897.798,
        "transcript": "Tuaten tua-i alingnarqetacia. Alingnaqsaaq[luni].",
        "translation": "That's how scary it is. It's scary."
    },
    "135": {
        "startTime": 897.805,
        "endTime": 907.667,
        "transcript": "Tua-i waten ayuqenritlermeggni iqukvat tamaita tua-i waten neqsuutelliqellermeggni-llu.",
        "translation": "This was when they weren't like now, every [?famine], and when they didn't have modern fishing implements."
    },
    "136": {
        "startTime": 908.393,
        "endTime": 914.43,
        "transcript": "Atam tua-i tamaa-i tamana tua-i alikellrukeka wiinga.",
        "translation": "You see, I was scared of that."
    },
    "137": {
        "startTime": 914.443,
        "endTime": 923.143,
        "transcript": "Maa-i unuamek nalqegcipiartukut, wiinga-ll' ilalirluci, makunek-llu freezer-aanek.",
        "translation": "We're living in easy times today, and I'm with you, and [we have] these freezers."
    },
    "138": {
        "startTime": 923.162,
        "endTime": 927.625,
        "transcript": "Qangvallauciilngurmek nutak'acagarmek nernariaqan iliini ner'aqluta.",
        "translation": "Sometimes we eat something fresh that we don't know how old it is."
    },
    "139": {
        "startTime": 927.637,
        "endTime": 930.887,
        "transcript": "Uum canimelli'irrluku qanengssakartua.",
        "translation": "I'm telling a story closer to this time."
    },
    "140": {
        "startTime": 930.894,
        "endTime": 936.931,
        "transcript": "Tuaten tua-i ayuqellrulliniut yuut au͡gkut yuullermeggni.",
        "translation": "That's what they were like when people back then lived."
    },
    "141": {
        "startTime": 936.944,
        "endTime": 939.219,
        "transcript": "Camek tua-i...",
        "translation": "Something..."
    },
    "142": {
        "startTime": 940.225,
        "endTime": 944.888,
        "transcript": "Waten Kassiyurturatullruut allamiaqan.",
        "translation": "They would hold a Kassiyuq dance festival every year."
    },
    "143": {
        "startTime": 944.9,
        "endTime": 948.575,
        "transcript": "Kassiyuq una yugnek kelgiyarauguq.",
        "translation": "For Kassiyuq, they invite people."
    },
    "144": {
        "startTime": 949.281,
        "endTime": 957.081,
        "transcript": "Una yuulaq nunat pikaat tamarmeng kelenrilnge'rmeng.",
        "translation": "This yuulaq pair of ceremonial drums belong to all villages, even if they don't send invitations."
    },
    "145": {
        "startTime": 957.55,
        "endTime": 963.3,
        "transcript": "Yuulalituut cauyagnek malrugnek eciriluteng",
        "translation": "They make a yuulaq pair by putting skins on two drums"
    },
    "146": {
        "startTime": 964.607,
        "endTime": 970.657,
        "transcript": "Atakutangssaaryungaqameng-wa tua-i qakemkut neqangssaliaritnek.",
        "translation": "When they want to start dinner, the food that the women out there made."
    },
    "147": {
        "startTime": 970.764,
        "endTime": 974.414,
        "transcript": "Uumek au͡gna cimiqerluku piqatartua.",
        "translation": "I'm going to change that topic to this."
    },
    "148": {
        "startTime": 974.633,
        "endTime": 978.171,
        "transcript": "Cauyagnek malrugnek eciriaqut.",
        "translation": "They put skins on two drums."
    },
    "149": {
        "startTime": 978.175,
        "endTime": 984.913,
        "transcript": "Tua-i-llu tan'geraaraan cauyak im' kaugtuarlukek.",
        "translation": "Then when it starts getting dark, they beat the two drums."
    },
    "150": {
        "startTime": 984.926,
        "endTime": 992.601,
        "transcript": "Au͡gna-w' aataka, au͡gna-llu ug'um arnassaga'urluum aatii akiqliqlutek aturpagatullruuk",
        "translation": "My father, and the father of the old woman downriver would sing opposite each other"
    },
    "151": {
        "startTime": 992.62,
        "endTime": 996.42,
        "transcript": "Tau͡gaam yuarutkek elitellrunritanka.",
        "translation": "But I didn't learn their songs."
    },
    "152": {
        "startTime": 996.427,
        "endTime": 1000.164,
        "transcript": "Anglanissiyaaglua pillruaqama elicuitanka.",
        "translation": "When I have too much fun, I don't learn them."
    },
    "153": {
        "startTime": 1000.177,
        "endTime": 1003.977,
        "transcript": "Canek elisngangqerrsaaqua ilaitnek yuarutet iqupkuitnek.",
        "translation": "I have some incomplete knowledge of songs."
    },
    "154": {
        "startTime": 1003.996,
        "endTime": 1010.671,
        "transcript": "Tua-i iqukiareskan man'a nallunrilkemnek aturciqua Yugcetun.",
        "translation": "When this is over, I will song some that I know in Yup'ik."
    },
    "155": {
        "startTime": 1010.677,
        "endTime": 1013.665,
        "transcript": "Aturpaganaurtuk.",
        "translation": "They would sing loudly."
    },
    "156": {
        "startTime": 1014.115,
        "endTime": 1025.153,
        "transcript": "Tua-i-ll' piuraqerluni arnaq iterluni qasgimun imumek neruka'rmek tegumiarluni, qantamek.",
        "translation": "Then eventually, a woman would enter the community house holding a nerukar, a [ceremonial] bowl."
    },
    "157": {
        "startTime": 1026.503,
        "endTime": 1035.541,
        "transcript": "Kanavet-llu nacitem qainganun ellirraarluku yurarluni, wagg'uq ingularluni. Taqngami-llu anluni.",
        "translation": "Then after she put it down on the floor down there, she would dance what they called an Ingulaq dance. Then she went out when she was done."
    },
    "158": {
        "startTime": 1036.116,
        "endTime": 1042.004,
        "transcript": "Muluvkenani tuavet arnaq itertuq qantunguarmek tegumiarluni.",
        "translation": "Before long, a women entered there holding a bowl."
    },
    "159": {
        "startTime": 1042.025,
        "endTime": 1044.462,
        "transcript": "Kiituani tang una",
        "translation": "Eventually, here"
    },
    "160": {
        "startTime": 1044.469,
        "endTime": 1048.832,
        "transcript": "Nacitat tua-i uutun waten ayalertutatullruut.",
        "translation": "The floor planks used to be as [?slanted] as this."
    },
    "161": {
        "startTime": 1048.844,
        "endTime": 1053.507,
        "transcript": "Kenillra qasegpiim, nacitet-llu waten.",
        "translation": "The fireplace of the big community house, and the floor planks like this."
    },
    "162": {
        "startTime": 1053.519,
        "endTime": 1058.019,
        "transcript": "Muirnaurtuq imkunek qancunguarnek neruka'rnek.",
        "translation": "It owuld be filled with those nerukar bowls."
    },
    "163": {
        "startTime": 1058.026,
        "endTime": 1062.251,
        "transcript": "Itenriata-ll' tua-i nutaan cauyak qerrlukek.",
        "translation": "And when the stopped coming in, they'd put the drums away."
    },
    "164": {
        "startTime": 1062.27,
        "endTime": 1069.42,
        "transcript": "Nerluteng imkut qasgimiut Kass'artauyugnailngurnek",
        "translation": "The men of the community house would eat food that absolutely was not Western"
    },
    "165": {
        "startTime": 1069.436,
        "endTime": 1081.024,
        "transcript": "Qamiquyagarnek tepnek, mak'anek, puyanek, qerpertanek, neqerrluarnek.",
        "translation": "Little fermented salmon heads, aged salmon egg ice cream, moss with aged seal oil, whitefish roe ice cream, dried fish."
    },
    "166": {
        "startTime": 1081.037,
        "endTime": 1087.712,
        "transcript": "Wangkuta tan'gurralle'rni tua-i, \"Puyat-assirtut,\" wagg'uq puyat.",
        "translation": "We boys [would say], \"Moss with aged seal oil is good,\" what they call puya"
    },
    "167": {
        "startTime": 1088.537,
        "endTime": 1093.174,
        "transcript": "Puyat, puyautet",
        "translation": "Puyat, moss with aged seal oil"
    },
    "168": {
        "startTime": 1093.412,
        "endTime": 1103.212,
        "transcript": "Yuut puyautaicuitellruut. Urut imkut, urut uqumek mecirluki, au͡gkut urut nunam urui.",
        "translation": "People were never without puyat. That moss, soak the moss in seal oil, the moss from the land."
    },
    "169": {
        "startTime": 1103.219,
        "endTime": 1106.781,
        "transcript": "Urucararmiunek qanlalriit maani. Urut.",
        "translation": "There's Urucararmiut [People of Moss]. Moss."
    },
    "170": {
        "startTime": 1106.794,
        "endTime": 1108.707,
        "transcript": "Uqumek mecirluki.",
        "translation": "Soak them in seal oil."
    },
    "171": {
        "startTime": 1108.719,
        "endTime": 1116.594,
        "transcript": "Puyaliqataameng-llu tua-i tauna uru meciumakii [?] passiqcaarluku uqumek kuv'aqluku.",
        "translation": "And when they were going to make puya, they'd crush that soaked moss and pour seal oil into it."
    },
    "172": {
        "startTime": 1116.6,
        "endTime": 1119.9,
        "transcript": "Qatkacagarluni tua-i, eyucuarluni.",
        "translation": "It was very white, and a little congealed."
    },
    "173": {
        "startTime": 1119.907,
        "endTime": 1125.544,
        "transcript": "Tau͡gaam tamakut puyat egmian neryaraugut tua-i cukangnaqluteng.",
        "translation": "But those puyat need to be eaten right away, and quickly."
    },
    "174": {
        "startTime": 1125.557,
        "endTime": 1132.094,
        "transcript": "Wagg'uq teng[luni]. Uitaskuni tua-i qivia allakarluku tengluni.",
        "translation": "They say it \"flies away.\" If you leave it, the berries separate and \"fly away.\""
    },
    "175": {
        "startTime": 1132.107,
        "endTime": 1133.944,
        "transcript": "Tuaten tua-i.",
        "translation": "Like that."
    },
    "176": {
        "startTime": 1133.957,
        "endTime": 1136.419,
        "transcript": "Assipiat neqet",
        "translation": "Such good food"
    },
    "177": {
        "startTime": 1136.432,
        "endTime": 1139.757,
        "transcript": "Qamiquyagarnek tua-i tuaten.",
        "translation": "Including litte [fish] heads."
    },
    "178": {
        "startTime": 1139.763,
        "endTime": 1148.301,
        "transcript": "Tua-ll' tua-i cali uksumi",
        "translation": "Then also, in the winter"
    },
    "179": {
        "startTime": 1148.314,
        "endTime": 1155.489,
        "transcript": "Uksumi una cali apqiit Itruka'ar",
        "translation": "In the winter, the \"Inviting-In Feast\" Itruka'ar"
    },
    "180": {
        "startTime": 1155.508,
        "endTime": 1161.133,
        "transcript": "Makumiut Itruka'armek acituat yuraryaraq.",
        "translation": "The people call that dance festival Itruka'ar."
    },
    "181": {
        "startTime": 1161.289,
        "endTime": 1169.277,
        "transcript": "Apqaitnek Itruka'ar tauna anglukurtarnek yuarutetangqertuq, yuarutengqetuut.",
        "translation": "During what they call Itruka'ar, they have shaman songs."
    },
    "182": {
        "startTime": 1169.29,
        "endTime": 1174.627,
        "transcript": "Itrukaraliarameng angulkullret au͡gkut tangtullruanka.",
        "translation": "When they brought in the Itruka'ar bowls, I used to see those shamans."
    },
    "183": {
        "startTime": 1174.64,
        "endTime": 1184.552,
        "transcript": "Ellaita yuratuit, malrugnek arnaunregnek, ataucirrarmek angutngunercirluku.",
        "translation": "They would dance, with two women, and one single man to join them."
    },
    "184": {
        "startTime": 1184.565,
        "endTime": 1191.778,
        "transcript": "Nutaan-llu makut piyulriit elitaameggnek cali angalkuunrilnge'rmeng tua-i.",
        "translation": "And those who wanted to, [would dance] whatever they knew though they weren't shamans."
    },
    "185": {
        "startTime": 1191.79,
        "endTime": 1196.503,
        "transcript": "Unisteka-w' yuiarucitullruuq puqignitullruatni.",
        "translation": "My late parents would write songs because they said he was skilled."
    },
    "186": {
        "startTime": 1196.515,
        "endTime": 1200.665,
        "transcript": "Itruka'ar una tamatuuguq.",
        "translation": "That is what this Itruka'ar festival is."
    },
    "187": {
        "startTime": 1200.684,
        "endTime": 1204.822,
        "transcript": "Itruka'armek agayumek acirluku pituluteng.",
        "translation": "They called it the Itruka'ar ceremony."
    },
    "188": {
        "startTime": 1204.835,
        "endTime": 1209.16,
        "transcript": "Una-w' aipaa Kevgiq.",
        "translation": "And the other one, Kevgiq, the Messenger Feast."
    },
    "189": {
        "startTime": 1209.166,
        "endTime": 1211.891,
        "transcript": "Yuraryaraq nutaan.",
        "translation": "Now that's a dance festival."
    },
    "190": {
        "startTime": 1211.91,
        "endTime": 1217.697,
        "transcript": "Nunat waten Kevgirqameng",
        "translation": "When villages held this Kevgiq Feast"
    },
    "191": {
        "startTime": 1219.86,
        "endTime": 1221.722,
        "transcript": "Ukut nunalget",
        "translation": "This village"
    },
    "192": {
        "startTime": 1222.26,
        "endTime": 1235.435,
        "transcript": "Waniwa waten mean-iqerluku: kelegyukuvet tua-i elpet camek piyuumatengqerquvet, Tuntutuliarmun ayagceciyartuten angutegnek malrugnek kevgagnek.",
        "translation": "This is the meaning I ascribe to it: if you want to send an invitation for something that you want, you would send two men, kevgak [messengers], to Tuntutuliak."
    },
    "193": {
        "startTime": 1235.441,
        "endTime": 1242.591,
        "transcript": "Qalurrirlukek, tua-i alerqurlukek tuaten. Tuaten tua-i.",
        "translation": "[?Tell them], and describe to them [what you want]. Like that."
    },
    "194": {
        "startTime": 1242.61,
        "endTime": 1246.948,
        "transcript": "Ukuk wani kevgak aya'agqamek",
        "translation": "When these two messengers went"
    },
    "195": {
        "startTime": 1246.961,
        "endTime": 1259.123,
        "transcript": "Tuani kingunermegni mikelnguq tauna aatii piyuumatii tuani ciunragni ilurii, ilurii aqvaniluku kevgirniluku.",
        "translation": "They would refer a child's father's request from their home to their destination, saying that they're getting, inviting, his cross-cousin."
    },
    "196": {
        "startTime": 1259.136,
        "endTime": 1263.124,
        "transcript": "Ayuqeliluku-ll' tua-i. Tuaten tua-i.",
        "translation": "And he'd also make a request. Like that."
    },
    "197": {
        "startTime": 1263.137,
        "endTime": 1268.724,
        "transcript": "Canek tua-i piyuuterluteng Kevgirqameng",
        "translation": "They'd have different requests furing the Kevgiq Feast"
    },
    "198": {
        "startTime": 1268.737,
        "endTime": 1275.062,
        "transcript": "Nutegnek, kapkaanarnek, ikamragnek.",
        "translation": "Guns, steel traps, a sled."
    },
    "199": {
        "startTime": 1275.068,
        "endTime": 1282.368,
        "transcript": "Canek tua-i piyungssaarlutneg, iluriinun cali ikayuasqelluku.",
        "translation": "They would want some various things, and ask their cross-cousins to help."
    },
    "200": {
        "startTime": 1282.387,
        "endTime": 1290.137,
        "transcript": "Tua-i-llu Kass'aqsiginermeggteggun pingameng pelarvagmek-llu piaqut.",
        "translation": "Then when they did that further into Western contact, they'd ask for huge tents."
    },
    "201": {
        "startTime": 1290.144,
        "endTime": 1293.481,
        "transcript": "Pelarvagmek pelatekaryugluteng.",
        "translation": "They wanted huge tents."
    },
    "202": {
        "startTime": 1293.494,
        "endTime": 1300.881,
        "transcript": "Aglirtuusqelluku-llu nutegmek anarrluurqualriamek ugaan' nutaraam.",
        "translation": "He'd also ask him to [?bring] a gun that was so new that it was as black as feces."
    },
    "203": {
        "startTime": 1300.894,
        "endTime": 1308.669,
        "transcript": "Tua-i-gguq, pit wani, tan'gerpiit ciikallrat tunguuq, tua-i taman' umyuaqluku.",
        "translation": "They said it because of how black crowberry diarrhea is."
    },
    "204": {
        "startTime": 1308.675,
        "endTime": 1315.4,
        "transcript": "Tuaten tua-i yuraq Kevgiryaraq ayuqellruuq anguvilqallrenka.",
        "translation": "That's what the Kevgiq dance festival was like where I was born in time to remember."
    },
    "205": {
        "startTime": 1315.406,
        "endTime": 1319.856,
        "transcript": "Tuaten tua-i wiinga-ll' ilagaqaullua Kevgilriani.",
        "translation": "I would also join the Kevgiq Feast like that."
    },
    "206": {
        "startTime": 1319.863,
        "endTime": 1326.375,
        "transcript": "Tau͡gaam tua-i angutngunerciucugyaaqekiitnga, aren yuraneq, yurayuitua.",
        "translation": "But they asked me to be the male dancer, oh my, I didn't Yup'ik dance."
    },
    "207": {
        "startTime": 1326.376,
        "endTime": 1330.676,
        "transcript": "Tau͡gaam aturpagatullruunga cauyarteńguaqlua-llu",
        "translation": "But I would sing and be a drummer."
    },
    "208": {
        "startTime": 1331.07,
        "endTime": 1332.808,
        "transcript": "Tua-llu?",
        "translation": "Well?"
    },
    "209": {
        "startTime": 1332.821,
        "endTime": 1336.021,
        "transcript": "Calirraq, cali-qaa cangimirtuten?",
        "translation": "Do you want to listen to more?"
    },
    "210": {
        "startTime": 1336.028,
        "endTime": 1339.803,
        "transcript": "Ii-i, makut-mi?",
        "translation": "Yes, what about these?"
    },
    "211": {
        "startTime": 1339.822,
        "endTime": 1343.922,
        "transcript": "Angalkugnek-qaa piciatun angullrunrituten?",
        "translation": "Were you born in time to see any shamans?"
    },
    "212": {
        "startTime": 1343.929,
        "endTime": 1351.679,
        "transcript": "Tangerqallrunrituten angalkull'e'rnek tuunrillralrianek piciatun alingnarquuralrianek?",
        "translation": "Have you eveer seen shamans doing any scary shamanistic magic?"
    },
    "213": {
        "startTime": 1352.386,
        "endTime": 1365.948,
        "transcript": "Aren tuunrilriit waten angalkut tamakut tamaani yuut atullruit ciuliamta.",
        "translation": "Oh my, the shamans who practiced their powers back then, the people, our ancestors, practiced them."
    },
    "214": {
        "startTime": 1365.961,
        "endTime": 1371.461,
        "transcript": "Ciuliaput piciatun yuullrunritut au͡gkut.",
        "translation": "Our ancestors back then didn't not live purposelessly."
    },
    "215": {
        "startTime": 1372.455,
        "endTime": 1379.33,
        "transcript": "Tamakut angalkut atullrulliniit ukvekpiarluki.",
        "translation": "They practiced shamanism with complete faith in them."
    },
    "216": {
        "startTime": 1380.311,
        "endTime": 1386.899,
        "transcript": "Yuum temiinek ikayuringnaqelriit naulluulrianek",
        "translation": "The ones who try to help the bodies of the sick"
    },
    "217": {
        "startTime": 1386.912,
        "endTime": 1392.399,
        "transcript": "Umyuarrliqenrilnguut, umyuarrlugciyuilnguut",
        "translation": "Those without malicious intent, who do not have malicious intent for others"
    },
    "218": {
        "startTime": 1393.024,
        "endTime": 1405.624,
        "transcript": "Tamakut angalkut atullermeggni yuut piciuluteng atullrulliniit ukvekluki, law-rit-llu aturluki.",
        "translation": "When those poeple practiced shamanism, they truly practiced it with faith, and followed their laws."
    },
    "219": {
        "startTime": 1405.631,
        "endTime": 1419.131,
        "transcript": "Waten cuq'lirituut: tallimani ernerni una anirtungnaqkeseng uluarasqevkenaku.",
        "translation": "They set this period of time: they told the ones they were trying to save not to use a knife for five days."
    },
    "220": {
        "startTime": 1419.138,
        "endTime": 1421.3,
        "transcript": "Tua-i tuaten.",
        "translation": "Like that."
    },
    "221": {
        "startTime": 1421.301,
        "endTime": 1429.701,
        "transcript": "Tang-gguq ilii, piciungami",
        "translation": "Look, they said, some people, since it's true"
    },
    "222": {
        "startTime": 1429.72,
        "endTime": 1432.82,
        "transcript": "Iciw'... ukaqsigiqerlua qalangssakarlii.",
        "translation": "You know... let me come closer to speak."
    },
    "223": {
        "startTime": 1432.827,
        "endTime": 1439.127,
        "transcript": "Iciw' Agayutem Satan-aq paat'naqellrukii, an'giliurta tauna.",
        "translation": "You know, Satan was God's partner, that high-ranking angel."
    },
    "224": {
        "startTime": 1439.146,
        "endTime": 1447.059,
        "transcript": "Tua-i-llu piciungami ukvekesteńi niisnga[ciqaa].",
        "translation": "Then since it's true, one who believes in it will obey it."
    },
    "225": {
        "startTime": 1447.071,
        "endTime": 1451.896,
        "transcript": "Yaa, piciatun akusrarutnguluni tau͡gaam atullrunritliniat.",
        "translation": "Yes, but they didn't mess around with it aimlessly."
    },
    "226": {
        "startTime": 1451.902,
        "endTime": 1458.74,
        "transcript": "Tuunritarkateng, qasgimi tuunrilrianek tangtullruunga cauyarluteng.",
        "translation": "The one they use spirit powers on, I would see them practicing shaman magic with drums in the community house."
    },
    "227": {
        "startTime": 1459.203,
        "endTime": 1462.528,
        "transcript": "Tua-i-llu-wa-gguq tamaani ciungani",
        "translation": "Then they said that in the past back then"
    },
    "228": {
        "startTime": 1466.097,
        "endTime": 1477.047,
        "transcript": "Tuunritarkaq-gguq piyuasciigalnguq akigarluku qasgitaqaat, arnaq angun-llu, angalkuk malruk.",
        "translation": "They said that the one that two shamans were going to use their powers on who couldn't walk, they would bring them to the community house, woman and man."
    },
    "229": {
        "startTime": 1479.341,
        "endTime": 1494.241,
        "transcript": "Tua-lli-wa-gguq iliini piluaqaumaaqami taukuk imkuk ikayuqlutek caarrluinek imkunek, caarrluinek nang'iluku.",
        "translation": "Then they said that when that person was [healed] well, those two [shamans] would help to get rid of all of his impurities."
    },
    "230": {
        "startTime": 1494.46,
        "endTime": 1498.773,
        "transcript": "Piyuasciiganani itleq, piyualuni-gguq an'aquq.",
        "translation": "They said the one who couldn't walk in, would go out walking."
    },
    "231": {
        "startTime": 1498.785,
        "endTime": 1502.648,
        "transcript": "Tua-i nangluku naulluutii au͡g'arluku.",
        "translation": "They would get rid of all of his ailment."
    },
    "232": {
        "startTime": 1502.66,
        "endTime": 1504.735,
        "transcript": "Tuaten tua-i.",
        "translation": "Like that."
    },
    "233": {
        "startTime": 1504.741,
        "endTime": 1510.841,
        "transcript": "Tua-llu cali ilii-am waten",
        "translation": "Then also, some of them like this"
    },
    "234": {
        "startTime": 1510.86,
        "endTime": 1521.898,
        "transcript": "Angalkum ilii yugmek umyuarrliquciluni piaqan, tauna-gguq yuk naulluugura'arqan naken kelgulluku.",
        "translation": "When some shamans harbered malicious intent toward a person, when that person was sick for a long time, he'd invite him from somewhere."
    },
    "235": {
        "startTime": 1525.698,
        "endTime": 1532.648,
        "transcript": "Kelgulluku. Taun'-gguq naken tekitaquq. Pistii tang yuaraqaa.",
        "translation": "[The shaman] invites him. They say he arrives from somewhere. You see, he looks for who invited him."
    },
    "236": {
        "startTime": 1532.655,
        "endTime": 1539.017,
        "transcript": "Tamaantelliniaqan-gguq qaspessaagulluku pisqaqaku",
        "translation": "They said that when he's there and tells him to go get a thin pullover garment"
    },
    "237": {
        "startTime": 1539.03,
        "endTime": 1547.305,
        "transcript": "Nutaan imumek umyuarrluutiinek angicivka'rqaa tauna, umyuarrliquskii au͡g'aritelluku.",
        "translation": "He has [that shaman] with malicious intent go free, having him forgive him for his malicious intent."
    },
    "238": {
        "startTime": 1547.324,
        "endTime": 1551.811,
        "transcript": "Tua-i caarkaunrirluni tua-i, tuqutairulluni.",
        "translation": "He becomes safe, without the threat of death."
    },
    "239": {
        "startTime": 1552.786,
        "endTime": 1555.336,
        "transcript": "Tuaten ayuqelliniut.",
        "translation": "That's what they're like."
    },
    "240": {
        "startTime": 1555.718,
        "endTime": 1562.168,
        "transcript": "Tua-i tau͡gaam cali tamaani cali ciuqvatagni",
        "translation": "But also, back then in the distant past"
    },
    "241": {
        "startTime": 1562.187,
        "endTime": 1571.812,
        "transcript": "Arcaqassiyaalria, arcaqassiyaagluni pilria tua-i kasnguksugnaunaku.",
        "translation": "The one who was too bad, they would feel no shame about what they would do to him."
    },
    "242": {
        "startTime": 1571.818,
        "endTime": 1577.993,
        "transcript": "Tua-i tuqutetullrulliniat angalkuq nallunailqurpassautessiyaalria.",
        "translation": "They would kill the shaman that was too infamous."
    },
    "243": {
        "startTime": 1578.012,
        "endTime": 1587.012,
        "transcript": "Tau͡gaam-gguq eyurtekangqeng'e'rmi aullu inerquusngaluni eyuqaasqevkenaku.",
        "translation": "However, they said that though one would defend him, they would admonish them against ever defending them."
    },
    "244": {
        "startTime": 1587.019,
        "endTime": 1599.506,
        "transcript": "Tau͡gam-gguq imkut saaniicuaraat, tamakut tau͡gaam tatamuravkaqateki-gguq tau͡gaam nutaan piyugtacimegcetun akiureskilitgu.",
        "translation": "But they said those little kettles, only when those startle them should they retaliate as much as they want."
    },
    "245": {
        "startTime": 1599.519,
        "endTime": 1602.081,
        "transcript": "Tua-i tuaten mean-angqelliniuq.",
        "translation": "That's what it means."
    },
    "246": {
        "startTime": 1602.094,
        "endTime": 1606.532,
        "transcript": "Ii-i. Camek cali piyugcit?",
        "translation": "Okay. What else do you want?"
    },
    "247": {
        "startTime": 1606.545,
        "endTime": 1617.37,
        "transcript": "Niitelartukut ircenrrarnek, yucuayaarnek, [?] caugat tayima.",
        "translation": "We hear about ircenrraat, [legendary] little people, [?], whatever they are."
    },
    "248": {
        "startTime": 1617.376,
        "endTime": 1622.314,
        "transcript": "Ircenrrarnek-qaa tangerqaqsaituten yuucirpeni?",
        "translation": "Have you never seen legendary little people in your life?"
    },
    "249": {
        "startTime": 1622.327,
        "endTime": 1628.714,
        "transcript": "Ircenrraat yucuayagaunritut qanraqameng.",
        "translation": "Ircenrraat aren't little people when they speak [of them]."
    },
    "250": {
        "startTime": 1630.214,
        "endTime": 1633.114,
        "transcript": "Tau͡gam-gguq tevirayuut.",
        "translation": "But they say they can disappear in an instant."
    },
    "251": {
        "startTime": 1634.996,
        "endTime": 1645.683,
        "transcript": "Aataka qalangssalartuq [?Iigirayuk] uaken uksuillminek anssiirluni, kuigem ceńiikun anguarturluni.",
        "translation": "My father tells stories of [?Iigirayuk], hunting seal from his winter camp downriver, rowing on the riverbank."
    },
    "252": {
        "startTime": 1645.696,
        "endTime": 1653.308,
        "transcript": "Atam igvalliniuq qayaqegtaar man'a asgulria tunglirnerakun.",
        "translation": "You see, a high quality kayak appeared coming upriver toward him."
    },
    "253": {
        "startTime": 1653.321,
        "endTime": 1658.059,
        "transcript": "Ukut-wa iciw' kuigni iliini napat ketmun uyangqatulriit.",
        "translation": "And these, you know how sometimes in rivers, trees are bent towards the water?"
    },
    "254": {
        "startTime": 1658.072,
        "endTime": 1661.672,
        "transcript": "Akunlekqerluki tua-i qayaqegtaar.",
        "translation": "A high quality kayak went between them."
    },
    "255": {
        "startTime": 1661.679,
        "endTime": 1671.104,
        "transcript": "Tua-i-ll' taukut tekilluki umyuarteqliniuq, \"Aling, mat'umi-lli ukaqsigpaa qayaqegcilriami.\"",
        "translation": "Then he thought when he reached them, \"Wow, this one with a great kayak is so close.\""
    },
    "256": {
        "startTime": 1671.935,
        "endTime": 1684.61,
        "transcript": "Ukut tua-i tekicarturluki, unisteḿa tekicaaqellinii taukut kavirlit uyangqalriit kuimteńi un'gani, \"Qaku-gguq una igvarta?\" Pellullinii.",
        "translation": "He approached them, and when my late father reached the bent red trees in our river downriver, \"When is this going to appear?\" He had passed them."
    },
    "257": {
        "startTime": 1684.616,
        "endTime": 1687.341,
        "transcript": "Tayim' catauani.",
        "translation": "It was gone."
    },
    "258": {
        "startTime": 1687.36,
        "endTime": 1689.622,
        "transcript": "Tua-i ircenrraq-gguq.",
        "translation": "He said it was a little person."
    },
    "259": {
        "startTime": 1689.635,
        "endTime": 1695.073,
        "transcript": "Tuamtellu qalangssagmek au͡gkuk",
        "translation": "Then those two [told] a story"
    },
    "260": {
        "startTime": 1696.398,
        "endTime": 1705.148,
        "transcript": "Anaanaq-wa Tuntuaq, Qeng'angiar-llu, tama[ani] im' anglicartellrak taukuk",
        "translation": "The maternal aunt Tuntuaq, and Qeng'angiar, the ones who raised them"
    },
    "261": {
        "startTime": 1705.155,
        "endTime": 1709.642,
        "transcript": "Pamani Aruvalnguum ceńiini uksuitulik.",
        "translation": "The ones who camp in the winter inland in Aruvalnguq."
    },
    "262": {
        "startTime": 1709.655,
        "endTime": 1715.98,
        "transcript": "Ipugluni can'giirnek nulirra.",
        "translation": "His wife ladled out blackfish."
    },
    "263": {
        "startTime": 1716.311,
        "endTime": 1720.386,
        "transcript": "Puqlanek atakutaqatarlutek.",
        "translation": "They were going to have a hot dinner."
    },
    "264": {
        "startTime": 1721.58,
        "endTime": 1727.617,
        "transcript": "Aruvalnguum piani, piani Qemiller uitauq ekvicugpak.",
        "translation": "Inland from Aruvalnguq is Qemiller, a huge bluff."
    },
    "265": {
        "startTime": 1727.63,
        "endTime": 1731.855,
        "transcript": "Maaten piqalliniuk ikamrat.",
        "translation": "They realized that there were sleds."
    },
    "266": {
        "startTime": 1731.874,
        "endTime": 1734.099,
        "transcript": "Kangiqutauguq tauna.",
        "translation": "That is an inlet."
    },
    "267": {
        "startTime": 1734.105,
        "endTime": 1741.143,
        "transcript": "Ikamrat upiit asmurluteng qeralriit.",
        "translation": "Moving sleds, the crossing [the inlet] by [?pushing their sleds]."
    },
    "268": {
        "startTime": 1741.156,
        "endTime": 1743.856,
        "transcript": "Tua-i tangvagluki.",
        "translation": "They watched them."
    },
    "269": {
        "startTime": 1743.863,
        "endTime": 1749.788,
        "transcript": "Imna tauna ekvik urenkelluku.",
        "translation": "They went straight for that bluff."
    },
    "270": {
        "startTime": 1751.194,
        "endTime": 1758.194,
        "transcript": "Aren, umyuartequk-gguq, \"Qaillun-kiq ekvik mayurniarta?\"",
        "translation": "Oh my, they said that they thought, \"How will they climb the bluff?\""
    },
    "271": {
        "startTime": 1758.663,
        "endTime": 1769.801,
        "transcript": "Tuarpiaq-gguq imna ekvicuk tekitellermeggni ellu'urtellriit, ekvik imna, may'uqertellermeggni.",
        "translation": "They said it seemed like they slid [up] when they reached the bluff, that bluff, when they climbed."
    },
    "272": {
        "startTime": 1769.814,
        "endTime": 1779.176,
        "transcript": "Pavani-gguq tau͡gken merunrani uvertellriami kayimpacugluteng tayim' ipluteng ircenrraat.",
        "translation": "However, they said that in the steep [?face] inland, the legendary little people [?pushed through] and disappeared."
    },
    "273": {
        "startTime": 1779.189,
        "endTime": 1782.639,
        "transcript": "Tua-i tuaten yucuaraunritut.",
        "translation": "They're not little people like that."
    },
    "274": {
        "startTime": 1782.658,
        "endTime": 1789.508,
        "transcript": "Tamakut ircenrraat yucuayaarnek apyuitait tangaastek'lallrita.",
        "translation": "Those who've seen them don't refer to ircenrraat as little people."
    },
    "275": {
        "startTime": 1789.515,
        "endTime": 1792.202,
        "transcript": "Wiinga tangerqanritua tau͡gaam.",
        "translation": "But I've never seen any."
    },
    "276": {
        "startTime": 1792.215,
        "endTime": 1800.915,
        "transcript": "Cali nunallritni tamaani cali qalangssagmek nallunritua.",
        "translation": "I also know of a story of one of their old settlements back then."
    },
    "277": {
        "startTime": 1800.928,
        "endTime": 1810.703,
        "transcript": "Ugna Agartessaagam-gguq un' qagatellra nanvallerpakayak nunallemta kiatiini.",
        "translation": "They said there was an old lake source of Agartessaagaq downriver, upriver from our old settlement."
    },
    "278": {
        "startTime": 1810.722,
        "endTime": 1819.934,
        "transcript": "Qungurtallrit-llu maa-i cali alaitut qungurtallrit, nunamun pulksaunateng.",
        "translation": "And their graves here, their graves are still visible, not having sunk into the ground."
    },
    "279": {
        "startTime": 1822.422,
        "endTime": 1828.485,
        "transcript": "Nukalpiat ayuqenrilameng qavavet-am Kialirmun sevtelliniat.",
        "translation": "Since great hunters were different, they cut the land upriver to Kialiq."
    },
    "280": {
        "startTime": 1830.572,
        "endTime": 1839.072,
        "transcript": "Agartessaagarmiurluq-gguq tauna arnassaga'urluq qiau͡rlurtuq, \"Iiiiii.\"",
        "translation": "They said that poor old woman from Agartessaagaq cried, \"Eeeeee.\""
    },
    "281": {
        "startTime": 1840.104,
        "endTime": 1851.766,
        "transcript": "Sev'tellrata-wa pau͡gkut capkutarkai qemit ellmeggnun kalivcameng qunuksaaqluki neqtuan akakiignek.",
        "translation": "When the hills that would bar their cutting through the land got stock on themselves, she didn't want them to be destroyed since they had a lot of broad whitefish."
    },
    "282": {
        "startTime": 1855.167,
        "endTime": 1863.254,
        "transcript": "Tua-ll' ceńii tauna kellirnermi ircenrrartangqellrulliniami",
        "translation": "Then since there were legendary little people on the bank toward the water there"
    },
    "283": {
        "startTime": 1863.429,
        "endTime": 1878.242,
        "transcript": "Atam iliit alakartelliniuq angyaq. Nanvakun paug͡kut manialkut apqiitnek Sugtulim manialkut tungiikun qerallinilria angyaq.",
        "translation": "You see, one of them noticed a boat. A boat was crossed the jagged ice of the lake inland, through the jagged ice of what they call Sugtuli."
    },
    "284": {
        "startTime": 1880.079,
        "endTime": 1882.829,
        "transcript": "Qerrarukarallilria-wa.",
        "translation": "It was probably sailing."
    },
    "285": {
        "startTime": 1882.848,
        "endTime": 1889.373,
        "transcript": "Yui-gguq tang tua-i ayuqenrilngurnek aturluteng una-i",
        "translation": "They said the people on it had different kinds of clothes down there"
    },
    "286": {
        "startTime": 1889.379,
        "endTime": 1894.204,
        "transcript": "Kavirlinek tuaten canek tua-i atkuunrilngurnek.",
        "translation": "Even red things, things that weren't parkas."
    },
    "287": {
        "startTime": 1894.223,
        "endTime": 1899.61,
        "transcript": "Aling tua-i-gguq tang ciunerkani-ll' tamakut pitulriit.",
        "translation": "Oh my, they said those would happen in the future."
    },
    "288": {
        "startTime": 1899.623,
        "endTime": 1906.998,
        "transcript": "Tua-i-ll' tuani-am nunallra taun elallalliniat yull'eraat.",
        "translation": "Then the people back then would dig into the land that had been there."
    },
    "289": {
        "startTime": 1907.004,
        "endTime": 1912.392,
        "transcript": "Au͡g'um-ll' ug'um aiparma atsiyarqameng elalalliniit.",
        "translation": "And my spouse downriver, they'd dig them when they picked berries."
    },
    "290": {
        "startTime": 1912.405,
        "endTime": 1920.03,
        "transcript": "Tumaumayuitut-gguq ircenrraat aklullrit. Ciqumumarrlainarluteng tumaumayuunateng.",
        "translation": "They said ircenrraq things don't leave trails for long. They always break apart, never staying trails for long."
    },
    "291": {
        "startTime": 1920.049,
        "endTime": 1924.736,
        "transcript": "Ik'iki-gguq iciw' saskat imkut kelassat?",
        "translation": "They said there were so many, you know those glass cups?"
    },
    "292": {
        "startTime": 1924.749,
        "endTime": 1930.811,
        "transcript": "Tamakunek [?eriniqumkacagaumaluteng] pitangqerrnaurtuq.",
        "translation": "There would be those [?scattered all over]."
    },
    "293": {
        "startTime": 1930.824,
        "endTime": 1941.737,
        "transcript": "Elliin-llu tua-i taum aiparma ug'um aanairutiin qalangssakai nassaurluuluni tanglallrulliniami.",
        "translation": "And my spouse's late mother would tell stories of those when we was a little girl because she would see them."
    },
    "294": {
        "startTime": 1942.074,
        "endTime": 1944.399,
        "transcript": "Tumaumayuunateng.",
        "translation": "Their trails wouldn't last long."
    },
    "295": {
        "startTime": 1944.405,
        "endTime": 1947.443,
        "transcript": "Canek-gguq taluyallruarnek-llu.",
        "translation": "They said they had things, fish traps."
    },
    "296": {
        "startTime": 1947.456,
        "endTime": 1960.256,
        "transcript": "Nasaurluq-gguq tua-i waten taluyallruarmek tumaqcaarmek ilakengkuni, tua-i-gguq tan'gaurlurmek yung'arkaulliniuq ertem iliini pivakarluni.",
        "translation": "They said that when a girl gets a handmade fish trap like this, she will get a male child someday in the future."
    },
    "297": {
        "startTime": 1960.263,
        "endTime": 1965.688,
        "transcript": "Tua-i ciunerkamek-gguq pituut tamakut tuaten.",
        "translation": "They say those tell the future like that."
    },
    "298": {
        "startTime": 1965.707,
        "endTime": 1970.644,
        "transcript": "Iliit-llu-gguq-am caqerluni tuani tua-i elagpakarluni elagluteng",
        "translation": "They also said that one day, when they'd been digging there"
    },
    "299": {
        "startTime": 1970.657,
        "endTime": 1975.357,
        "transcript": "Imkut cuyatangqetullruuq qillertarnek.",
        "translation": "There used to be those twisted tobacco leaves."
    },
    "300": {
        "startTime": 1975.364,
        "endTime": 1984.951,
        "transcript": "Irulurugarnek-gguq-am tua-i qillrutarluteng. Tua-i, tua-i-gguq cuyarpagninaqluni.",
        "translation": "They said that there were lots of twisted tobacco leaves. They said they smelled like tobacco."
    },
    "301": {
        "startTime": 1984.964,
        "endTime": 1989.326,
        "transcript": "Tangerrluku. Ciunerkamek-gguq pituut tamakut.",
        "translation": "You see? They say those tell the future."
    },
    "302": {
        "startTime": 1989.339,
        "endTime": 1994.477,
        "transcript": "Ii-i. Tua-llu?",
        "translation": "Okay. Well [anything else]?"
    },
    "303": {
        "startTime": 2001.665,
        "endTime": 2006.852,
        "transcript": "Tua-llu? Time-airutukut-qaa?",
        "translation": "Well? Are we out of time?"
    },
    "304": {
        "startTime": 2006.865,
        "endTime": 2008.815,
        "transcript": "Atuqerciqua tau͡gaam.",
        "translation": "I'll sing, however."
    },
    "305": {
        "startTime": 2008.834,
        "endTime": 2010.584,
        "transcript": "Ii-i, yaa.",
        "translation": "Okay, yes."
    },
    "306": {
        "startTime": 2015.716,
        "endTime": 2022.741,
        "transcript": "Atuqaa kitak'. Qalamcikqerraarluku atu'urkan caucianek atuqerniaran.",
        "translation": "Please sing. Please talk about what your song is about, then sing."
    },
    "307": {
        "startTime": 2022.76,
        "endTime": 2024.385,
        "transcript": "Tua-llu?",
        "translation": "Ready?"
    },
    "308": {
        "startTime": 2025.616,
        "endTime": 2033.204,
        "transcript": "Quyatmek Qaluvialleraam yuarutiinek Kevgillermeggni.",
        "translation": "Qaluvialler's song of gratitude when they held the Messenger Feast."
    },
    "309": {
        "startTime": 2033.217,
        "endTime": 2039.754,
        "transcript": "Maa-i tua-i atqestii qerrulliniuq, kiugum panian yua",
        "translation": "Now, his namesake froze to death, the child of the daughter of the one upriver"
    },
    "310": {
        "startTime": 2041.079,
        "endTime": 2046.442,
        "transcript": "Papam, Pugleralriim, taum Qaluvialleraam atqestii.",
        "translation": "Papaq, Pugleralria, Qaluvialler's namesake."
    },
    "311": {
        "startTime": 2046.454,
        "endTime": 2054.342,
        "transcript": "Kiugna Papaq, taum tua-i yuarutem mat'um atuqerarkama panikaa, piipiqaa.",
        "translation": "Papaq upriver is the daughter, the baby of the song that I'm going to sing."
    },
    "312": {
        "startTime": 2055.267,
        "endTime": 2064.43,
        "transcript": "Tuaten tua-i Kevgililuteng-am yuarucillrulliniuq angniutmek imangqenrilngurmek, arivutmek-ll' imangqerpek'nani",
        "translation": "When they held the Messenger Feast, he apparently wrote a song not about happiness, and not about insult"
    },
    "313": {
        "startTime": 2064.442,
        "endTime": 2067.405,
        "transcript": "Tau͡gaam ukveraitmek quyatmek.",
        "translation": "But about unbelievable gratitude."
    },
    "314": {
        "startTime": 2067.417,
        "endTime": 2069.342,
        "transcript": "Quyan-qaa nallunritan?",
        "translation": "Do you know about gratitude?"
    },
    "315": {
        "startTime": 2069.486,
        "endTime": 2072.573,
        "transcript": "Quyaaqavet qaill' umyuangqelarcit?",
        "translation": "What's your mindset when you're thankful?"
    },
    "316": {
        "startTime": 2072.936,
        "endTime": 2074.273,
        "transcript": "Angniq.",
        "translation": "Happiness."
    },
    "317": {
        "startTime": 2074.286,
        "endTime": 2078.898,
        "transcript": "Angniq-wa tua-i quyan. Tuaten mean-angqertuq.",
        "translation": "Gratitude is happiness. That's what it means."
    },
    "318": {
        "startTime": 2079.911,
        "endTime": 2090.724,
        "transcript": "Tua-i tamatumek atuqaqatartua waniw' ak'allarnek qalamciama Kuigilngurmi Kevgirluteng yuarutellratnek.",
        "translation": "I'm going to sing that song they sang during the Messenger Feast in Kwigillingok since I'm telling stories about a long time ago."
    },
    "319": {
        "startTime": 2090.737,
        "endTime": 2097.324,
        "transcript": "Carraquinrauguq. Nanilengraan tua-i agnermek ataucimek waniw' tua-i atuqatartua.",
        "translation": "It's short. Though it's short, I'm now going to sing one stanza."
    },
    "320": {
        "startTime": 2097.337,
        "endTime": 2107.374,
        "transcript": "Kinkut imkut niicugnilriit-wa asguranaitkacagarmek, piciulrianek qalangssagtua.",
        "translation": "To anyone listening, I'm telling stories of things that are not unbelievable, but are true."
    },
    "321": {
        "startTime": 2107.387,
        "endTime": 2119.087,
        "transcript": "Iluramni qakemkuni, waniw' tua-i atengqertua Kunuin Qinarmiu, Tuntutuliaraam nunaliaqestii.",
        "translation": "To my cousins out there, my name is Kunuin from Qinaq, who has moved to Tuntutuliar."
    },
    "322": {
        "startTime": 2119.094,
        "endTime": 2123.419,
        "transcript": "Tuntutuliar-llu 1945 nunaliaqellrukeka.",
        "translation": "I moved to Tuntutuliar in 1945."
    },
    "323": {
        "startTime": 2123.431,
        "endTime": 2130.131,
        "transcript": "Tua-i unuamek waniwa quyatekaqa KYUK-t kelgatnga.",
        "translation": "Today, I am thankful that KYUK invited me."
    },
    "324": {
        "startTime": 2130.138,
        "endTime": 2138.15,
        "transcript": "Elluatussiyaanricaaqua. Pelluusqelluku waniw' arenqialluguteka quyatekluku atuqatartua.",
        "translation": "I'm not doing very well. I'm going to sing of gratitude to have my misfortune pass."
    },
    "325": {
        "startTime": 2138.151,
        "endTime": 2144.338,
        "transcript": "Nutaan akertem tanqiani cali elluarrluta ilakluta tamamta pekcuumirluta.",
        "translation": "Let us all desire to walk well together under the light of the sun."
    },
    "326": {
        "startTime": 2144.438,
        "endTime": 2150.263,
        "transcript": "Quyaukut tagi-yara-ya",
        "translation": "We're thankful tagi-yara-ya"
    },
    "327": {
        "startTime": 2150.282,
        "endTime": 2155.644,
        "transcript": "Kanangqaukut tagi-yara-ya",
        "translation": "We're bowing tagi-yara-ya"
    },
    "328": {
        "startTime": 2155.657,
        "endTime": 2160.707,
        "transcript": "Ii-rri-rri-yarrai",
        "translation": "Ii-rri-rri-yarrai"
    },
    "329": {
        "startTime": 2160.714,
        "endTime": 2165.214,
        "transcript": "Elingranaqvaa agya-rrai",
        "translation": "What a cause for gratitude agya-rrai"
    },
    "330": {
        "startTime": 2165.233,
        "endTime": 2170.833,
        "transcript": "Quyaukut tagi-yara-ya",
        "translation": "We're thankful tagi-yara-ya"
    },
    "331": {
        "startTime": 2170.84,
        "endTime": 2175.952,
        "transcript": "Kanangqaukut tagi-yara-ya",
        "translation": "We're bowing tagi-yara-ya"
    },
    "332": {
        "startTime": 2175.965,
        "endTime": 2181.015,
        "transcript": "Ii-rri-rri-yarrai",
        "translation": "Ii-rri-rri-yarrai"
    },
    "333": {
        "startTime": 2181.034,
        "endTime": 2186.122,
        "transcript": "Elingranaqvaa agya-rrai uu!",
        "translation": "What a cause for gratitude agya-rra-rrai uu!"
    },
    "334": {
        "startTime": 2186.135,
        "endTime": 2189.085,
        "transcript": "Tua-i-wa tua-i.",
        "translation": "There you have it."
    },
    "335": {
        "startTime": 2189.429,
        "endTime": 2191.229,
        "transcript": "Tua-llu?",
        "translation": "How was that?"
    },
    "336": {
        "startTime": 2193.373,
        "endTime": 2196.036,
        "transcript": "Quyanaqvaa cakneq.",
        "translation": "Thank you very much."
    },
    "337": {
        "startTime": 2197.248,
        "endTime": 2202.961,
        "transcript": "Ii-i, quyakuvet tua-i cali yuarutkangqertua.",
        "translation": "Okay, if you're happy, I have another song."
    },
    "338": {
        "startTime": 2202.973,
        "endTime": 2208.961,
        "transcript": "Qalangssakuma cali iqupkumek aturyugngalua cali.",
        "translation": "If I tell another story, I can sing an incomplete song too."
    },
    "339": {
        "startTime": 2212.636,
        "endTime": 2223.974,
        "transcript": "Imna-qaa Apanuugpiim, Apanuugpak-qaa yuarutaituq?",
        "translation": "Does [the legendary hero] Apanuugpak have any songs?"
    },
    "340": {
        "startTime": 2224.237,
        "endTime": 2229.687,
        "transcript": "Tua-i yuarutiinek Apanuugpiim nallulrianga.",
        "translation": "I don't know any song about Apanuugpak."
    },
    "341": {
        "startTime": 2229.694,
        "endTime": 2240.344,
        "transcript": "When they would have the woman dancing during the Ingulaq festival, they'd be fast.",
        "translation": "When they would have the woman dancing during the Ingulaq festival, they'd be fast."
    },
    "342": {
        "startTime": 2240.351,
        "endTime": 2245.251,
        "transcript": "Anqarautnek-gguq anguyagtarnek.",
        "translation": "They called them songs of victory in war."
    },
    "343": {
        "startTime": 2245.27,
        "endTime": 2250.908,
        "transcript": "Tua-i tau͡gaam anglanissyaalaama Apanuugpallarnek tau͡gam nalluunga.",
        "translation": "But since I had too much fun, I don't know any songs about Apanuugpak."
    },
    "344": {
        "startTime": 2251.633,
        "endTime": 2253.796,
        "transcript": "Avani",
        "translation": "Back then"
    },
    "345": {
        "startTime": 2255.308,
        "endTime": 2264.521,
        "transcript": "Tamaani-gguq anguyatullermeggni, anguyangqellermeggni-w'",
        "translation": "They said that back when used to be at war, when they had wars"
    },
    "346": {
        "startTime": 2265.121,
        "endTime": 2275.483,
        "transcript": "Waken tua-i yuk ataucirrartaqami yugmek eyarluku kapluku [?] ilua qamyugluku.",
        "translation": "When one person killed another, they would tattoo by poking, [?] closing the inside."
    },
    "347": {
        "startTime": 2275.496,
        "endTime": 2281.046,
        "transcript": "Ilii-gguq tua-i iliini akulrarun tekisngaaqaa eyanek",
        "translation": "They say some would have tattoos reaching the middle of the forehead"
    },
    "348": {
        "startTime": 2281.053,
        "endTime": 2285.14,
        "transcript": "Igarcuutaitellermeggni pitami amlertaciitnek.",
        "translation": "When they didn't have markers, how many he had killed."
    },
    "349": {
        "startTime": 2285.153,
        "endTime": 2287.178,
        "transcript": "Tuaten tua-i.",
        "translation": "Like that."
    },
    "350": {
        "startTime": 2287.197,
        "endTime": 2294.884,
        "transcript": "Tua-i-llu yuarutmek cali ataucirrarmek una iqpkuk nallunritaqa.",
        "translation": "I also know one song, but [my knowledge is] incomplete."
    },
    "351": {
        "startTime": 2294.897,
        "endTime": 2298.272,
        "transcript": "Amani Iyuussiimi",
        "translation": "Over in Igushik"
    },
    "352": {
        "startTime": 2298.278,
        "endTime": 2306.866,
        "transcript": "Maaken-am tua-i taukut Apanuugpak-ll' ilakluku pillilriit, pingayurrauluteng pillret.",
        "translation": "From here, the three who were probably with Apanuugpak."
    },
    "353": {
        "startTime": 2306.879,
        "endTime": 2317.841,
        "transcript": "Tauna-gguq qayaq malirqallrat, maaten-gguq teguat eyarrarluni ataucimek tauna anguyak.",
        "translation": "They said that when they caught that kayak they were chasing, they found that that warrior had a single tattoo."
    },
    "354": {
        "startTime": 2317.854,
        "endTime": 2321.279,
        "transcript": "Cunaw' ataucirrartellrallrulliniuq Kusquqvagmiu tauna.",
        "translation": "Turns out, that person from the Kuskowkim had killed one."
    },
    "355": {
        "startTime": 2321.298,
        "endTime": 2326.485,
        "transcript": "Tua-i-llu yuarutmek aturnaurtut, \"Eyarralek Paiqatanemni-qaa?\"",
        "translation": "Then they sang a song, \"Right When I was Gong to Pass the One with a Tattoo?\""
    },
    "356": {
        "startTime": 2326.498,
        "endTime": 2329.935,
        "transcript": "Tua-i iquklituq au͡gna. Tua-i tuaten.",
        "translation": "That story ends. That's all there is to it."
    },
    "357": {
        "startTime": 2329.948,
        "endTime": 2334.085,
        "transcript": "Apanuugpiim yuarutiinek nalluunga tuaten.",
        "translation": "I don't know a song about Apanuugpak like that."
    },
    "358": {
        "startTime": 2334.385,
        "endTime": 2340.923,
        "transcript": "Tua-i Apanuugpak una anguyagni eneqayarauguq.",
        "translation": "Apanuugpak is [told] to remember wars."
    },
    "359": {
        "startTime": 2341.448,
        "endTime": 2345.986,
        "transcript": "Eneqakluku qalangssaguaqetullruat tauna",
        "translation": "They told stories of him to remember [wars]"
    },
    "360": {
        "startTime": 2348.286,
        "endTime": 2350.461,
        "transcript": "Avnerpak-llu.",
        "translation": "And Avnerpak."
    },
    "361": {
        "startTime": 2352.886,
        "endTime": 2355.786,
        "transcript": "Tua-i-w' quyanaqvaa. Time-airutukut.",
        "translation": "Thank you. We're out of time."
    },
    "362": {
        "startTime": 2355.793,
        "endTime": 2362.28,
        "transcript": "Ii-i. Wiinga-llu-w' tua-i quyalrianga waniw' piyunaqlua iquklicamku time-aq.",
        "translation": "Okay. I'm also thankful that I was able to make it to the end of our time well."
    },
    "363": {
        "startTime": 2363.38,
        "endTime": 2370.043,
        "transcript": "Yaa, tangrruuqalarciquten Yuut Qanruyutaitni pia[rkani].",
        "translation": "Okay, you'll be seen on the Traditional Yup'ik Wisdom program."
    },
    "364": {
        "startTime": 2370.23,
        "endTime": 2372.218,
        "transcript": "Ii-i. (Ii-i.)",
        "translation": "Okay. (Okay.)"
    },
    "365": {
        "startTime": 2372.231,
        "endTime": 2377.356,
        "transcript": "Tua-i pitsaqevkenii pinirikuma cali tua-i piyugngaunga.",
        "translation": "SHould I get stronger, I can [come] again."
    },
    "366": {
        "startTime": 2377.375,
        "endTime": 2378.062,
        "transcript": "Yaa.",
        "translation": "Okay."
    },
    "367": {
        "startTime": 2378.075,
        "endTime": 2380.45,
        "transcript": "Segganqeggikuma. (Ii-i.)",
        "translation": "When I have vigor. (Okay.)"
    }
};